import { fakeApi } from './fake'
import { httpApi } from './http'
import type { ConsoleApi } from './types'

// The fake account answers in `npm run dev` and the browser check; every
// deployed build calls its account host (VITE_API_ORIGIN).
export function makeApi(): ConsoleApi {
  if (import.meta.env.VITE_FAKE_API === '1') return fakeApi()
  return httpApi(import.meta.env.VITE_API_ORIGIN)
}

export * from './types'
